import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { GlassCard, Chip, Skeleton } from "@/v2/components/ui";
import { Table, PageHead } from "@/v2/admin/ui";
import { TYPE_TONE } from "@/masar/lib";
import { BookOpen } from "lucide-react";

export default function MasarMatrix() {
  const [type, setType] = useState("");
  const { data: comps = [], isLoading, error } = useQuery({
    queryKey: ["masar-comps", type],
    queryFn: async () => (await api.get(`/masar/admin/competencies?type=${type}`)).data,
  });
  return (
    <div className="space-y-5" data-testid="masar-matrix">
      <PageHead icon={BookOpen} title="دليل الجدارات" />
      <GlassCard className="p-5">
        <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
          <div className="font-bold">الجدارات ({comps.length})</div>
          <div className="flex gap-1">{[["", "الكل"], ["leadership", "قيادية"], ["behavioral", "سلوكية"], ["technical", "فنية"]].map(([k, l]) => <button key={k} onClick={() => setType(k)} data-testid={`comp-type-${k || "all"}`} className={`v2-btn-sm ${type === k ? "v2-btn" : "v2-btn-ghost"}`}>{l}</button>)}</div>
        </div>
        {error ? <p role="alert" className="text-sm text-ink-2">تعذّر تحميل الجدارات. أعد المحاولة.</p> : isLoading ? <Skeleton className="h-64 w-full" /> : (
          <Table head={["الجدارة", "النوع", "مسميات تطلبها", "عدد الموظفين"]} min={720} testId="comps-table">
            {comps.map((c) => (
              <tr key={c.id} data-testid="comp-row">
                <td className="font-semibold text-sm">{c.name}</td>
                <td><Chip tone={TYPE_TONE[c.type]}>{c.type_ar}</Chip></td>
                <td className="tabular-nums" dir="ltr">{c.profiles}</td>
                <td className="tabular-nums" dir="ltr">{c.employees}</td>
              </tr>
            ))}
          </Table>
        )}
      </GlassCard>
    </div>
  );
}
